/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { isCanlan } from '@sportninja/common/utils/customer-name'
import { useState } from 'react'
import { Container, Flex } from '../../components/Layout'
import GameRoster from './GameRoster'

const GameRosterUnified = ({
  isPublicRoute,
  game,
  isHomeTeamPlaceholder,
  isVisitingTeamPlaceholder,
  isHomeTeamEmptyRoster,
  isVisitingTeamEmptyRoster,
  isGenericGame,
  canViewHomeAttendanceInfo,
  canViewVisitorAttendanceInfo,
  ...rest
}) => {
  const [isHome, setIsHome] = useState(true)

  const rosterId = isHome ? game.homeGameRosterId : game.visitingGameRosterId
  const isPlaceholder = isHome
    ? isHomeTeamPlaceholder
    : isVisitingTeamPlaceholder
  const isEmptyRoster = isHome
    ? isHomeTeamEmptyRoster
    : isVisitingTeamEmptyRoster
  const canViewAttendanceInfo = isHome
    ? canViewHomeAttendanceInfo
    : canViewVisitorAttendanceInfo

  return (
    <div>
      <Container>
        <Flex
          noFlex
          column
          css={css`
            margin-top: 8px;
            margin-right: 16px;
          `}
        >
          <label
            css={css`
              font-size: 12px;
              line-height: 12px;
              height: 12px;
              margin-bottom: 8px;
              color: ${colors.NEUTRAL_50};
            `}
          >
            Team
          </label>
          <div
            css={css`
              display: inline-flex;
              align-items: center;
              gap: 2px;
              background-color: transparent;
              border: 1px solid ${colors.SECONDARY_200};
              border-radius: 8px;
              padding: 4px;
              height: 40px;
              margin-bottom: 16px;
            `}
          >
            <button
              type='button'
              onClick={() => setIsHome(true)}
              css={css`
                display: flex;
                align-items: center;
                justify-content: center;
                min-width: 98px;
                padding: 0 12px;
                height: 32px;
                border-radius: 6px;
                background-color: ${isHome
                  ? colors.SECONDARY_300
                  : 'transparent'};
                border: none;
                cursor: pointer;
                transition: all 0.2s ease;
                font-size: 14px;
                font-weight: ${isHome ? 700 : 400};
                line-height: 20.3px;
                color: ${colors.NEUTRAL_0};
                text-transform: capitalize;
                white-space: nowrap;
                max-width: 180px;
                overflow: hidden;
                text-overflow: ellipsis;

                &:hover {
                  background-color: ${isHome
                    ? colors.SECONDARY_300
                    : colors.SECONDARY_200};
                }

                &:active {
                  transform: scale(0.98);
                }
              `}
            >
              Home
            </button>
            <button
              type='button'
              onClick={() => setIsHome(false)}
              css={css`
                display: flex;
                align-items: center;
                justify-content: center;
                min-width: 98px;
                padding: 0 12px;
                height: 32px;
                border-radius: 6px;
                background-color: ${!isHome
                  ? colors.SECONDARY_300
                  : 'transparent'};
                border: none;
                cursor: pointer;
                transition: all 0.2s ease;
                font-size: 14px;
                font-weight: ${!isHome ? 700 : 400};
                line-height: 20.3px;
                color: ${colors.NEUTRAL_0};
                text-transform: capitalize;
                white-space: nowrap;
                max-width: 180px;
                overflow: hidden;
                text-overflow: ellipsis;

                &:hover {
                  background-color: ${!isHome
                    ? colors.SECONDARY_300
                    : colors.SECONDARY_200};
                }

                &:active {
                  transform: scale(0.98);
                }
              `}
            >
              Visiting
            </button>
          </div>
        </Flex>
      </Container>
      <GameRoster
        key={isHome ? 'home' : 'visiting'}
        isPublicRoute={isPublicRoute}
        gameId={game.id}
        isGameStarted={game.started}
        isGameCompleted={game?.completed || false}
        rosterId={rosterId}
        isPlaceholder={isPlaceholder}
        isEmptyRoster={isEmptyRoster}
        sportId={game.sport_id}
        isGenericGame={isGenericGame}
        canViewAttendanceInfo={canViewAttendanceInfo}
        {...rest}
      />
    </div>
  )
}

export default GameRosterUnified
